import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IAnswer, IApplication } from 'src/app/models/application-form/application-form.model';

@Component({
  selector: 'appform-product-info-questions',
  templateUrl: './product-info-questions.component.html',
  styleUrls: ['./product-info-questions.component.css']
})
export class ProductInfoQuestionsComponent implements OnInit {

  private static QUESTION_SET_CODE = 'progressive_commercial_overview';
  @Output() answerUpdate = new EventEmitter<IAnswer>();
  @Input() formData: IApplication;
  @Input() readOnly: boolean;
  public answers: IAnswer[]


  ngOnInit(): void {
    const questionSet = this.formData.questionSets.list.filter(queSet => queSet.question_set.code === ProductInfoQuestionsComponent.QUESTION_SET_CODE);
    if (questionSet?.length > 0)
      this.answers = questionSet[0].answers;
  }

  public onValueChanges(event) {
    const answer = this.updateAnswer(event.data);
    this.answerUpdate.emit(answer);
  }

  private updateAnswer(data: any): IAnswer {
    const answer = this.formData.questionSets
      .list.filter(queSet => queSet.question_set.code === ProductInfoQuestionsComponent.QUESTION_SET_CODE)[0]
      .answers.filter(ans => ans.question.code == data.code)[0];
    const tempAns: IAnswer = { ...answer };
    tempAns.choice_id = data.choice_id;
    tempAns.is_completed = !data.invalid;
    return tempAns;
  }
}
